import type { ReactNode } from "react";
import { CellText } from "@design-system/DataGrid";
import styles from "./TaskAvatarLabel.module.scss";

/** A read-only cell's avatar and name (a person, Kick, a client), the name truncating. */
export const TaskAvatarLabel = ({
    avatar,
    label,
}: {
    avatar: ReactNode;
    label: string;
}) => (
    <span className={styles.avatarLabel}>
        <span className={styles.avatar}>{avatar}</span>
        <CellText text={label} overflow="truncate" />
    </span>
);
